<template>
  <div
    :class="['v-select__option', { 'v-select__option--disabled': disabled }]"
    @click.stop.prevent="emitValue()"
    tabindex="0"
  >
    <slot></slot>
</div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    emitValue() {
      this.$parent.$emit(
        "setValue",
        this.$el.children.length > 0
          ? this.$el.children[0].innerText
          : this.$el.innerText
      );
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../sass/component.scss";

.v-select__option {
  max-height: 50px;
  padding: 1rem;
  cursor: pointer;
  transition: background-color 0.1s ease-in-out;
  z-index: 50;

  &:hover {
    background-color: theme-color("gray");
  }

  &:active {
    background-color: theme-color("gray");
  }

  &--active {
    color: theme-color("danger");
    pointer-events: none;
  }

  &--disabled {
    color: theme-color("placeholder");
    pointer-events: none;
    font-size: 0.9rem;
    max-height: 50px;
  }
}
</style>
